<template>
    <div class="app-container mt-5">
        <div class="page-title mb-3">
            <router-link to="/configuration">
                <span class="breadcrumb-link">
                    <v-icon class="breadcrumb-link-icon">settings</v-icon> Configuration du compte
                </span>
            </router-link>
            <v-icon>keyboard_arrow_right</v-icon>
            <span class="breadcrumb-item">
                <v-icon class="breadcrumb-item-icon">email</v-icon> Mes boîtes d'envoi
            </span>
        </div>


        <sender :singleMod="true"></sender>

    </div>
</template>

<script>
import Sender from "../../onboard/steps/Sender"
export default {
    name: "SenderConfig",
    components: { Sender }
}
</script>